var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 70,
    fill: "#F9FBFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6197_77860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4375 39.0156C72.756 65.0392 73.5932 89.6821 67.4375 112.17H101.863L67.4375 39.0156Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.362 112.574V17.5C59.445 55.4702 53.1939 90.6558 40.3867 112.17L64.362 112.574Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1682 122.832H100.633L113.544 111.152H26.25L31.1682 122.832Z",
    fill: "#000066"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6197_77860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyResources);
export default __webpack_public_path__ + "static/media/empty-resources.8c078e96cc91a7f96538f510b1664d1d.svg";
export { ForwardRef as ReactComponent };